













import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import ModelItem from "../ModelItem";

export default defineComponent({
  name: "ModelsList",
  components: { ModelItem },
  props: {
    models: { type: Array as () => UserPublicData[], default: () => [] },
    followedIds: { type: Array as () => string[], default: () => [], required: true },
  },
  setup() {
    const { authUser } = useAuthUser();

    return {
      authUser,
    };
  },
});
